// Úprava markdownu smlouvy z Legal pro zobrazení (tablet a telefon klientky, 3. 11. 2026).
// Smlouva je převedená z Wordu: nadpisy kapitol jsou „### **1\. Předmět**“, některé odstavce mají
// zbytečné „###“. Kapitoly převede na ## , ostatní ### na obyčejný text.
export function upravMd(md) {
  return String(md || "").split("\n").map((r) => {
    if (/^###\s*\**\s*\d+\\?\./.test(r)) return `## ${r.replace(/^###\s*/, "").replace(/\*\*/g, "")}`;
    if (/^\*\*\d+\\?\.\s/.test(r)) return `## ${r.replace(/\*\*/g, "")}`;
    if (/^###\s*$/.test(r)) return "";
    if (/^###\s/.test(r)) return r.replace(/^###\s*/, "");
    if (/^\*\s+###\s/.test(r)) return r.replace(/^\*\s+###\s*/, "* ");
    if (/^##\s/.test(r)) return r.replace(/^##\s/, "# ");
    return r;
  }).join("\n");
}

// Názvy kapitol pro boční navigaci: „3. Platba a storno“ → { cislo: "3", nazev: "Platba a storno" }.
export function kapitoly(md) {
  return upravMd(md).split("\n").filter((r) => /^##\s/.test(r)).map((r) => {
    const t = r.replace(/^##\s*/, "").replace(/\\/g, "").trim();
    const m = /^(\d+)\.\s*(.*)$/.exec(t);
    return { cislo: m ? m[1] : "", nazev: m ? m[2] : t };
  });
}
